module.exports = __webpack_public_path__ + "static/img/h8.13d95c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour3/h8.jpg
// module id = d2J+
// module chunks = 0